module.exports = __webpack_public_path__ + "img/46_4.61c792cd.png";